<div class="release-note">
  @if (releaseNoteHtml) {
    <div class="formatted-text" [innerHTML]="releaseNoteHtml"></div>
  }
</div>
